import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-fechar_c6ae7757492504b8ed7fcc043ae22da0",
  "use": "ic-fechar_c6ae7757492504b8ed7fcc043ae22da0-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"ic-fechar_c6ae7757492504b8ed7fcc043ae22da0\">\n    <defs>\n        <path id=\"ic-fechar_c6ae7757492504b8ed7fcc043ae22da0_a\" d=\"M12 1.2L10.8 0 6 4.8 1.2 0 0 1.2 4.8 6 0 10.8 1.2 12 6 7.2l4.8 4.8 1.2-1.2L7.2 6z\" />\n    </defs>\n    <use fill-rule=\"evenodd\" transform=\"translate(6 6)\" xlink:href=\"#ic-fechar_c6ae7757492504b8ed7fcc043ae22da0_a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id